import DRRImg from "../assets/drr.jpg";
import AruImg from "../assets/arunimamam.jpg";

const dataTestimonials = [
  {
    name: "Rtr. Vipul Agrawal",
    post: "District Rotaract Representative RID-3012 (2021-22)",
    message:
      "Having Drishti BPIT in RID 3012 is a pleasure for us and what makes this club outstanding is its members i.e. you all. Each and every member is just as amazing as the club is. Right from Project Vaarta, participation in World Breast Feeding week, Project Avanti, Mental Disorder Awareness program, project Awaaz, project Shakti, project Bliss, project Samarthan and various donation drives, this club has not just done it all but well done it all. We are super proud of you guys. Keep your work ethics in right direction and keep the process simple and belive in the process of success. #keeprotaracting #believeintheprocess",
    img: DRRImg,
  },
  {
    name: "Ms.Arunima Kumari",
    post: "Faculty Coordinator, Drishti",
    message:
      "Drishti has always been a personal passion of mine and lives in the core of my heart. It is my privilege that I am a founder coordinator of a society that always fosters their responsibility towards the under privileged. The society works very hard to deliver all possible facilities to all those who need it in times of crisis. We are passionate about the work of Drishti and how it is indulges in holistic development of society, and this has allowed me to feel proud to be a coordinator of this society.",
    img: AruImg,
  },
];

export default dataTestimonials;
